import { jsx } from "react/jsx-runtime";
import dynamic from "next/dynamic";
import { useCallback } from "react";
import { forwardNextDynamicRef } from "../../../../next/dynamic";
import {
  isPropControllersHandle
} from "../../../../state/modules/prop-controller-handles";
import { useIsPreview } from "../../hooks/use-is-preview";
const EditableText = forwardNextDynamicRef((patch) => dynamic(() => patch(import("./EditableText"))));
const ReadOnlyText = forwardNextDynamicRef((patch) => dynamic(() => patch(import("./ReadOnlyText"))));
function useRichText(data, control) {
  const textCallbackRef = useCallback(
    (handle) => {
      if (isPropControllersHandle(handle))
        handle?.setPropControllers?.(control == null ? null : { text: control });
    },
    [control]
  );
  const isPreview = useIsPreview();
  return isPreview ? /* @__PURE__ */ jsx(EditableText, { text: data, ref: textCallbackRef }) : /* @__PURE__ */ jsx(ReadOnlyText, { text: data, ref: textCallbackRef });
}
export {
  useRichText
};
//# sourceMappingURL=rich-text.js.map